'use client';

import Link from 'next/link';
import { useCart } from './CartProvider';

export default function Header() {
    const { cartCount, isMounted } = useCart();

    return (
        <header className="site-header">
            <div className="container header-container">
                <Link href="/" className="logo">
                    Simple Shop
                </Link>
                <nav className="header-nav">
                    <Link href="/products" className="nav-link">商店</Link>
                    <Link href="/cart" className="nav-link" style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                        <span>購物車</span>
                        {isMounted && cartCount > 0 && (
                            <span style={{
                                background: 'var(--primary)',
                                color: 'white',
                                fontSize: '0.75rem',
                                fontWeight: 'bold',
                                padding: '0.125rem 0.375rem',
                                borderRadius: '999px',
                                minWidth: '1.25rem',
                                textAlign: 'center'
                            }}>
                                {cartCount}
                            </span>
                        )}
                    </Link>
                </nav>
            </div>
        </header>
    );
}
